export const regionsFlat = {
  'ISO New England (ISO-NE)': {
    relatedOrganizations: ['5ef61536ce5eb5001776b321'],
    'state|Provinces': [
      'Connecticut',
      'Maine',
      'Massachusetts',
      'New Hampshire',
    ],
  },

  'Midcontinent ISO (MISO)': {
    relatedOrganizations: ['5efce45829365900154e8fe2'],
    'state|Provinces': [
      'Arkansas',
      'Illinois',
      'Indiana',
      'Iowa',
      'Kansas',
      'Kentucky',
      'Louisiana',
      'Michigan',
      'Minnesota',
      'Mississippi',
    ],
  },

  'New York ISO (NYISO)': {
    relatedOrganizations: ['5efd11ff6671250015a90a9b'],
    'state|Provinces': ['New York'],
  },
  'PJM Interconnection': {
    relatedOrganizations: ['5efcdf1e36f87e001523b645'],
    'state|Provinces': [
      'Illinois',
      'Indiana',
      'Iowa',
      'Kentucky',
      'Maryland',
      'Michigan',
      'New Jersey',
      'North Carolina',
      'North Dakota',
      'Ohio',
    ],
  },
  'Southwest Power Pool (SPP)': {
    relatedOrganizations: ['5efcea3b36f87e0015241668'],
    'state|Provinces': [
      'Arkansas',
      'Colorado',
      'Iowa',
      'Kansas',
      'Louisiana',
      'Minnesota',
      'Missouri',
      'Montana',
      'Nebraska',
      'New Mexico',
    ],
  },
  'Western Energy Imbalance Market': {
    relatedOrganizations: ['5f10ba8ed5c6f500156e710b'],
    'state|Provinces': [],
  },
  'California ISO (CAISO)': {
    relatedOrganizations: ['5efdf79e2b64270017d8495e'],
    'state|Provinces': ['California', 'Arizona', 'Nevada', 'New Mexico'],
  },
  'Electric Reliability Council of Texas (ERCOT)': {
    relatedOrganizations: ['5efdfe850e9fc00016ac6e0e'],
    'state|Provinces': ['Texas'],
  },
}
